window.handoffLoading = (function() {
   var m_jLoading,
       m_jFrame,
       m_jScreen,
       m_jPole,
       m_bStopped = false;
   
   function start() {
      m_jLoading = $("#handoffLoading");
      m_jPole = $("#handoffLoadingPole");
      m_jScreen = $("#handoffScreen");
      m_jFrame = $("#handoffFrame");
      m_jScreen.css({
         opacity: .7
      });
      animatePole();
      m_jLoading.show();
   }
   
   function animatePole() {
      m_jPole.css({"background-position-x" : 0});
      m_jPole.animate({"background-position-x" : -505}, 6000, 'linear', function() {
         if (!m_bStopped) {
            animatePole();
         }
      });
   }
   
   function stop() {
      m_jLoading.hide();
      m_bStopped = true;
   }
   
   return {
      start : start,
      stop: stop
   };
})();

window.VarInit = new function () {
   var self = this;

   self.start = function (vars) {
      $(document).ready(function() {
         $('#myc21Username').html(vars.userDisplayName);

         if ($("#proxyFrame").length === 0) {
            // Create a helper frame for XSS transactions
            var jFrame = $('<iframe id="proxyFrame" style="display: none" />');
            jFrame.attr('src', portalAjax.getPersonalUrl() + '/js/iframe.proxy.html');
            $(document.body).append(jFrame);
         }

         if (vars.authenticated == 'true') {
            myc21.setLoggedIn();
            $("#saveSearch").show();
            $("#saveSearch").css({'display':'block'});

            $(".myNotesContainer").show();
            $(".myNotesContainer").css({'display':'block'});

            $("#myNotesContainerTitle").show();
            $("#myNotesContainerTitle").css({'display':'block'});

            $("#propertyNote").val(vars.userNotes);
         }  else {
            $("#saveSearch").show();
            $("#saveSearch").css({'display':'block'});

            //show the login screen for the user to sign in
            if($("body").hasClass("liquidLayout")) {
               $("#saveSearch").find("#saveSearchButton").attr("onclick", "Track.doEvent('Hybrid Mapping', 'Left Lane', 'Select Login to My C21 to Save Search'); myc21.      loginForm.open(true);");
            } else {
               $("#saveSearch").find("#saveSearchButton").attr("onclick", "myc21.loginForm.open(true);");
            }
         }
      });

      window.ViewSession = new function () {
         // FIXME: This function will only return accurate favorites from the initially loaded page
         //        BUT since the user can change favorites w/o reloading the page, the
         //        information eventually becomes outdated...
         function arrayContains(arr, value) {
             var i = arr.length;
             while (i--) {
                 if (arr[i] === value) return true;
             }
             return false;
         }    
         
         /**
          * Set the favorite [blank]   
          * @param aItems {Array} the items to check against
          * @param elId {String|jQuery} the element to change
          * @param sId {String} the item's id
          * @return {Boolean} True if the item is a favorite, otherwise False
          */
         var setFavorite = function(aItems, elId, sId) {
            var jEl = (typeof elId == "string") ? $("#" + elId) : elId,
               bFavorite = arrayContains(aItems, sId);

            jEl.toggleClass('favorite', bFavorite);
            return bFavorite;
         }

         this.setFavoriteProperty = function(elId, sId) {
            return setFavorite(vars.favoriteProperties, elId, sId);
         }
         
         //Set the favorite agent   
         this.setFavoriteAgent = function(elId, sId) {
            return setFavorite(vars.favoriteAgents, elId, sId);
         }            
         
         //Set the favorite office   
         this.setFavoriteOffice = function(elId, sId) {
            return setFavorite(vars.favoriteOffices, elId, sId);
         }            
         
         //Set the Hidden property   
         this.setHiddenProperty = function(elId, sId) {
            if (arrayContains(vars.hiddenProperties, sId)) {
               $("#" + elId).addClass('hidden');
            }   
         }            
         
         //Set the Hidden agent   
         this.setHiddenAgent = function(elId, sId) {
            if (arrayContains(vars.hiddenAgents, sId)) {
               $("#" + elId).addClass('hidden');
            }   
         }            
         
         //Set the Hidden office   
         this.setHiddenOffice = function(elId, sId) {
            if (arrayContains(vars.hiddenOffices, sId)) {
               $("#" + elId).addClass('hidden');
            }   
         }     
            
         //Add a favorite property
         this.addFavoriteProperty = function(sId) {
            if (!arrayContains(vars.favoriteProperties, sId)) {
               var lastIndex = vars.favoriteProperties.length;
               vars.favoriteProperties[lastIndex] = sId;
            }      
         }       
         
         //Remove a favorite property
         this.removeFavoriteProperty = function(sId) {
            if (arrayContains(vars.favoriteProperties, sId)) {
               for(var i=0; i < vars.favoriteProperties.length; i++ ) {
                  if(vars.favoriteProperties[i] == sId) {
                     vars.favoriteProperties.splice(i,1); 
                  }           
               }
            }
         }
         
         //Add a Hidden property
         this.addHiddenProperty = function(sId) {
            if (!arrayContains(vars.hiddenProperties, sId)) {
               var lastIndex = vars.hiddenProperties.length;
               vars.hiddenProperties[lastIndex] = sId;
            }      
         }       
         
         //Remove a Hidden property
         this.removeHiddenProperty = function(sId) {
            if (arrayContains(vars.hiddenProperties, sId)) {
               for(var i=0; i < vars.hiddenProperties.length; i++ ) {
                  if(vars.hiddenProperties[i] == sId) {
                     vars.hiddenProperties.splice(i,1); 
                  }           
               }
            }
         }        
                 
         //Add a favorite Agent
         this.addFavoriteAgent = function(sId) {
            if (!arrayContains(vars.favoriteAgents, sId)) {
               var lastIndex = vars.favoriteAgents.length;
               vars.favoriteAgents[lastIndex] = sId;
            }      
         }       
         
         //Remove a favorite Agent
         this.removeFavoriteAgent = function(sId) {
            if (arrayContains(vars.favoriteAgents, sId)) {
               for(var i=0; i < vars.favoriteAgents.length; i++ ) {
                  if(vars.favoriteAgents[i] == sId) {
                     vars.favoriteAgents.splice(i,1); 
                  }           
               }
            }
         }
         
         //Add a Hidden Agent
         this.addHiddenAgent = function(sId) {
            if (!arrayContains(vars.hiddenAgents, sId)) {
               var lastIndex = vars.hiddenAgents.length;
               vars.hiddenAgents[lastIndex] = sId;
            }      
         }       
         
         //Remove a Hidden Agent
         this.removeHiddenAgent = function(sId) {
            if (arrayContains(vars.hiddenAgents, sId)) {
               for(var i=0; i < vars.hiddenAgents.length; i++ ) {
                  if(vars.hiddenAgents[i] == sId) {
                     vars.hiddenAgents.splice(i,1); 
                  }           
               }
            }
         }
         
         //Add a favorite Office
         this.addFavoriteOffice = function(sId) {
            if (!arrayContains(vars.favoriteOffices, sId)) {
               var lastIndex = vars.favoriteOffices.length;
               vars.favoriteOffices[lastIndex] = sId;
            }      
         }       
         
         //Remove a favorite Office
         this.removeFavoriteOffice = function(sId) {
            if (arrayContains(vars.favoriteOffices, sId)) {
               for(var i=0; i < vars.favoriteOffices.length; i++ ) {
                  if(vars.favoriteOffices[i] == sId) {
                     vars.favoriteOffices.splice(i,1); 
                  }           
               }
            }
         }
         
         //Add a Hidden Office
         this.addHiddenOffice = function(sId) {
            if (!arrayContains(vars.hiddenOffices, sId)) {
               var lastIndex = vars.hiddenOffices.length;
               vars.hiddenOffices[lastIndex] = sId;
            }         }       
         
         //Remove a Hidden Office
         this.removeHiddenOffice = function(sId) {
            if (arrayContains(vars.hiddenOffices, sId)) {
               for(var i=0; i < vars.hiddenOffices.length; i++ ) {
                  if(vars.hiddenOffices[i] == sId) {
                     vars.hiddenOffices.splice(i,1); 
                  }           
               }
            }
         }                           
      };

      if (window.Century21) window.Century21.ViewSession = window.ViewSession;
   };

   if (window.MyVars) {
      self.start(MyVars);
   }
};

// New site?
if ($("header.site-header").length > 0) {
   // Ditch legacy junk for new stuff
   window.portalSearch = new window.NewPortalSearch();
   window.SearchDropAnimator = window.portalSearch;
} else {
   /**
    * Singleton that manages the portal search
    */
   window.portalSearch = (function() {
      var m_strDefaultText, m_iSuggestTimeout, m_jBox, m_jReset, m_jButton,
         m_strLastRequest, m_bTextDirty, m_iChangeTimeout, m_bIndexPage, m_bHasFocus,
         m_jBehind, m_tooltip, m_bUserStoppedTooltip,
         m_internationalization = window.internationalization,

         m_aC21ListingGuids = new Array(),
         m_aC21Listings = new Array(),
         m_aAgents = new Array(),
         m_aOffices = new Array();

      /**
       * Request a portal search
       * @param bEnterPressed Whether the user pressed enter to trigger the search
       */
      function doPortalSearch(bEnterPressed) {
         var val = m_jBox.val(), options;
         var suggestType = $("#suggestType").val();
        var isExactLocationMatch = $("#isExactLocationMatch").val();

         //Perform a submit and search for the single location properties or an exact matched location properties
         if( (suggestType == 'SINGLE_LOCATION' || isExactLocationMatch == 'true') && bEnterPressed) {
          var locationID = $("#singleLocationID").val();
          if(locationID && locationID.length > 0) {
             freeTextSearch.gaTrackExactLocationMatch(locationID, $("#singleLocationType").val());    		 
               freeTextSearch.propertySearch(locationID, 'N', bEnterPressed);
               return false;
          }    
         } 
         
         //GA Tracking - Exact Match Details (Property/Agent/Office)
         if(suggestType == 'SINGLE_PROPERTY' && bEnterPressed) {
           var brandCd = $("#propertyBrandCd").val();
           Track.doEvent('Free Text Search', 'Select property details for brand ' + brandCd);
         }
         
         if(suggestType == 'SINGLE_AGENT' && bEnterPressed) {
           Track.doEvent('Free Text Search', 'Select agent details');
         }
         
         if(suggestType == 'SINGLE_OFFICE' && bEnterPressed) {
           Track.doEvent('Free Text Search', 'Select office details');
         }
         
         // Why would you search for the default text?
         if (val == m_strDefaultText) return;
         
         var e = $("#e").val();
         
         if (bEnterPressed || (val != m_strLastRequest)) {
            options = {
               loadingIndicator : new TallLoadingIndicator('#innerSearch'),
               cache: true
            };
            m_jBox.addClass('searchValue');
            m_bTextDirty = true;
            m_strLastRequest = val;
            portalAjax.doViewEngineAjax('indexView.SuggestSubView',
                  '/freetextsearch.c21', 'q=' + encodeURIComponent(val)
                        + ((bEnterPressed) ? '&e=1' : ''), options);
         } else if (m_strLastRequest) {
            if (!m_bHasFocus) {
               return;
            }
         
            SearchDropAnimator.showSearchDrop();
         }
      }

      /**
       * Add an agent to track
       */
      function pushAgent(key){
         m_aAgents.push(key);
      }

      /**
       * Add an office to track
       */
      function pushOffice(key){
         m_aOffices.push(key);
      }

      /**
       * Add a listing to track
       */
      function pushC21Listing(listingkey, listingGUID){
         // If the key does not contain CBR, ERA or LCE...
         if (listingkey.indexOf("CBR") < 0 && listingkey.indexOf("ERA") < 0 && listingkey.indexOf("LCE") < 0) {
            m_aC21Listings.push(listingkey.replace("C21", ""));
            m_aC21ListingGuids.push(listingGUID);
         }
      }

      /**
       * Track Agents
       */
      function trackAgents() {
         if (m_aAgents.length != 0) {
            trackInternally(m_aAgents, 'agent');
         }
      }

      /**
       * Track Offices
       */
      function trackOffices() {
         if (m_aOffices.length != 0) {
            trackInternally(m_aOffices, 'office');
         }
      }

      /**
       * Track Listings
       */
      function trackListings() {
         if (m_aC21Listings.length == 0) return;

         trackInternally(m_aC21Listings, 'listing');

         // ListHub tracking
         if ($.browser.msie  && parseInt($.browser.version) == 7) {
            // Do not use listHub, otherwise IE7 would bomb out
         } else {
            // Smart browser
            $.each(m_aC21ListingGuids, function(i, c21Listing) {
               listHub.doTrackingC21(c21Listing, 'SEARCH_DISPLAY');
            });
         }
      }

      /**
       * Send an AJAX request to internally track items
       *
       * @param aItemIds         the ids of items to be tracked
       * @param strTrackingType  the type of item being tracked ('agent', 'listing', etc)
       */
      function trackInternally(aItemIds, strTrackingType) {
         // Track internally
         var strItemIds = "id=" + aItemIds.join("&id=");
         portalAjax.report({
            url: "/reporting/" + strTrackingType,
            data: strItemIds + "&type=RetSearch"
         });
      }

      function doSearchShowEvent() {
         var val = m_jBox.val();
         
         m_bTextDirty = true;
         if (val.length == 0) {
            m_jReset.hide();
            SearchDropAnimator.hideSearchDrop();
         } else if (val != m_strDefaultText) {
            m_jReset.show();         
            if ((val.length >= 3) || (val.length >= 1 && $("#e").val() == 1)) {
               clearTimeout(m_iSuggestTimeout);
               m_iSuggestTimeout = setTimeout(doPortalSearch, 100, false);
            } else {
               SearchDropAnimator.hideSearchDrop();
            }
         }
      }

      function setBehindText(str) {
         if (str) {
            var strSearchVal = m_jBox.val(),
               strBackgroundValue = strSearchVal + str.slice(strSearchVal.length);
      
            if (strSearchVal.toLowerCase() == str.slice(0, strSearchVal.length).toLowerCase()) {
               m_jBehind.val(strBackgroundValue);
            } else {
               m_jBehind.val('');
            }
         }
      }

      function showSearchHint(str, fnOnFinish) {
         var iFadeTime = 100,

            // Get the value of the original text
            strOriginalText = m_jBox.val();

         m_jBox.fadeOut(iFadeTime, function() {
            var strNewText = m_jBox.val();

            // If the text has changed while the animation was underway
            // (for instance, user clicks inside text box and changes stuff)
            if (strOriginalText != strNewText) {
               m_jBox.show();

               // Abort!!
               return;
            }

            m_jBox.val(str);
            m_jBox.fadeIn(iFadeTime, fnOnFinish);
         });
      }

      function removeSearchHint() {
         m_jBox.val(str);
         m_jBox.fadeIn(iFadeTime, fnOnFinish);
      }
      
      function onSubmit() {
        Track.doEvent('Free Text Search', 'Search listings, agents, offices, or locations by Search C21 button click');
         doPortalSearch(true);
      }
      
      function onReset() {
         m_jBox.val('');
         onChange();
         m_jBox.focus();
         updateBackgroundValue();
      }

      function updateBackgroundValue() {
         var strSearchVal = m_jBox.val(),
            strBackgroundValue = m_jBehind.val();

         if ((strSearchVal == '') || (strSearchVal != strBackgroundValue.slice(0, strSearchVal.length))) {
            m_jBehind.val('');
         }
      }
      
      function onChange() {
         clearTimeout(m_iChangeTimeout);
         clearTimeout(m_iSuggestTimeout);

         // setTimeout to prevent animation collision
         m_iChangeTimeout = setTimeout(doSearchShowEvent, 20);
      }
      
      function onFocus() {
         m_jBehind.show();
         m_bHasFocus = true;
         if (!m_jBox.hasClass('searchValue')) {
            m_jBox.addClass('searchValue');
            m_jBox.val('');
         }

         //Clear the enter key stroke event
         $("#e").val("");

         doSearchShowEvent();
         stopTooltip();
      }
      
      function onBlur() {
         m_jBehind.hide();
         m_bHasFocus = false;
         if ((m_jBox.val()).trim() === '') {
            m_jBox.val(m_strDefaultText);
            m_jBox.removeClass('searchValue');
         }
      }
      
      function fixExpanding() {
         var jExpandingDivs = $("#locationResultsInnerDiv, #propertyResultsInnerDiv, #officeResultsInnerDiv, #agentResultsInnerDiv");

         jExpandingDivs.on("click", function(e) {
            if (e.target != this) return; // only continue if the target itself has been clicked

            var jThis = $(this);
            jThis.find('.moreLinkDiv a, .showLessLinkDiv a').click();
         });
      }

      function doCollapsing() {
         $(".ftsCollapse").each(function() {new WordCollapsasaurus($(this));});
      }
      
      function enlargeClickTargets() {
         var bSuggestIconClicked = false;

         $(".disabledSuggestIcon").find("a").attr("href", "javascript:void(0);");
         $(".suggestIcon").on('hover', 
            function() {$(this).addClass('hover');}, 
            function() {$(this).removeClass('hover');})
         .on("click", function() {
            if (bSuggestIconClicked) return;
            bSuggestIconClicked = true;

            var jLink = $(this).find("a");
            if (jLink.attr("onclick")) {
               jLink.click();
            }

            document.location.href = jLink.attr("href");
         });
      }

      /**
       * Handles finding highlighted matches
       * @param strNeedle  the string to look up
       * @param strHaystack the string to look at
       * @return a matche with beginning/end character positions
       */
      function getHighlightPositions(strNeedle, strHaystack) {
         // Regex to eliminate unnecessary characters
         var regCondense = /([^a-z0-9]| )/gi,

            // Needle without unnecessary characters
            strNeedleCondensed = strNeedle.replace(regCondense, '').toLowerCase(),

            // The beginning / end indexes of a word in the condensed haystack
            iBeginIndex = 0,
            iEndIndex = 0,

            strSearch = '(^|[^a-z0-9])(' + strNeedleCondensed.split('').join('([^a-z0-9]*|[^a-z0-9]+(street|drive|st|rd|blvd|ln)[^a-z0-9]+)?') + ')([^a-z0-9]*)',
            regSearch = new RegExp(strSearch, 'i'),
            result = strHaystack.match(regSearch);

         if (result !== null) {
            iBeginIndex = result.index;

            if (result[1].length > 0) {
               iBeginIndex++;
            }

            var iTrailHaystack = result[result.length - 1].length,
               matchTrailNeedle = strNeedle.match(/[^a-z0-9]*$/),
               iTrailNeedle = 0,
               iTrail = 0;

            if (matchTrailNeedle !== null) {
               iTrailNeedle = matchTrailNeedle[0].length;
               iTrail = Math.min(iTrailHaystack, iTrailNeedle);
            }

            iEndIndex = result.index + result[0].length - 1 - iTrailHaystack + iTrail;

            return {
               begin: iBeginIndex,
               end: iEndIndex
            };
         }

         return null;
      }

      function doHighlight() {
         var strSearch = m_jBox.val(),
            jContent = $("#dropdownContent"),
            jAllItems = jContent.find('.ftsHighlight, .ftsHighlightMls'),
            jMlsItems = jContent.find('.ftsHighlightMls');

         // If there's nothing to look for then why bother?
         if ((strSearch).trim() == '') return;

         // Remove previous instances of highlighting
         jContent.find("span.freetextsearchmatched").contents().unwrap();

         jAllItems.each(function(i, el) {
            var jItem = $(el),
               jCollapsedItem = jItem.find('span span');

            // Sometimes the Collapsasaurus runs before this.
            // We want that to work, but we don't want html
            // mixed up in here
            if (jCollapsedItem.length > 0) {
               jItem = jCollapsedItem.eq(0);
            }

            // Use .text() so as to disregard HTML, &nbsp; or
            // any other funny stuff that could accidentally be highlighted
            var strText = jItem.text(),
               strNewHtml = strText,
               match = getHighlightPositions(strSearch, strText);

            if (strText == "") return;
            if (match == null) return;

            var iBegin = match.begin,
               iEnd = match.end - match.begin + 1;

            strNewHtml = strNewHtml.substr(0, iBegin) + "<span class='freetextsearchmatched'>" +
               strNewHtml.substr(iBegin, iEnd) + '</span>' + strNewHtml.substr(iBegin + iEnd);

            jItem.html(strNewHtml);
         });
      }
      
      function onKeyDown(event) {
         var iKeyCode = event.keyCode;

         // ENTER key
         if (iKeyCode == 13) {
            //GA Tracking - enter key
            Track.doEvent('Free Text Search', 'Search listings, agents, offices, or locations with enter key');
             
            doPortalSearch(true);
            return false;
         // UP arrow
         } else if (iKeyCode == 38) {
            SuggestPortalExtension.moveUp();
            return false;
         // RIGHT arrow or TAB key
         } else if (iKeyCode == 39 || iKeyCode == 9) {
            var strBehindText = m_jBehind.val();
            if (strBehindText) {
               m_jBehind.val('');
               m_jBox.val(strBehindText);
               onChange();
               return false;
            }
         // DOWN arrow
         } else if (iKeyCode == 40) {
            SuggestPortalExtension.moveDown();
            return false;
         } else {
            onChange();
         }
      }

      function showTooltipCombo(strTextBox, strToolTip, fnOnFinish) {
         m_tooltip.showText(strToolTip);
         showSearchHint(strTextBox, fnOnFinish);
      }

      function stopTooltip() {
         m_bUserStoppedTooltip = true;
         if (m_tooltip) {
            m_tooltip.hide();
         }
      }

      /**
       * Self-operating suggestion automaton
       */
      var SuggestionAutomaton = (function() {
         // The delay, in milliseconds, between messages
         var iDelay = 3000,
      
            // The messages...
            aMessages = [
               { title: "Boston, MA", tooltip: "Search millions of properties..." },
               { title: "Anaheim, CA", tooltip: "Find Agents or Offices in your area..." },
               { title: "Denver, CO", tooltip: "Explore facts about neighborhoods..." },
               { title: "Philadelphia, PA", tooltip: "Easily locate rentals near you..." },
               { title: "85251", tooltip: "View all homes in or near a zip code..." }
            ],

            // The index of the current message in aMessages
            iPosition = 0;

         /**
          * Show the next suggestion!
          */
         function showNextTooltip() {
            var message = aMessages[iPosition];

            // If the user has stopped the tooltip
            if (m_bUserStoppedTooltip) {
               // Hide the tooltip
               m_tooltip.hide();

               // Run away
               return;
            }

            // If there are no more messages to show - hide
            if (message == null) {
               m_tooltip.hide();
               showSearchHint(m_strDefaultText);
               return;
            }

            showTooltipCombo(message.title, message.tooltip, function() {
               iPosition++;
               setTimeout(showNextTooltip, iDelay);
            });
         }

         return {
            /**
             * Begin the process of flashy suggestions
             */
            dazzle: function() {
               // No dazzling allowed without a search box
               if ((!m_jBox)|| m_jBox.length === 0) return;

               // Do not show suggestions if user has already searched for stuff
               if (m_jBox.hasClass('searchValue')) return;

               // If we're not on the homepage
               if (window.viewEngineName !== "freetextsearch") {
                  // Don't do anything for now... (per AF)
                  return;
               }

               // Create the Tool Tip
               m_tooltip = new TooltipOneLine(m_jBox);

               // Fire away
               showNextTooltip();
            }
         };
      }());

      // Commented out temporarily per C21 until we decide what
      // suggestions to use with FTS...
      //$(document).ready(SuggestionAutomaton.dazzle);

      return {
         pushC21Listing: pushC21Listing,
         trackListings: trackListings,
         pushAgent: pushAgent,
         trackAgents: trackAgents,
         pushOffice: pushOffice,
         trackOffices: trackOffices,
         showSearchHint: showSearchHint,
         createSearchField : function() {
            m_jBehind = $('#behindSearchText');
            m_jBox = $('#searchText');
            m_jReset = $('#searchReset');
            m_jButton = $('#searchButton');
            m_jButton.on('click', onSubmit);
            m_jReset.on('click', onReset);
            m_jBox.on('keydown', onKeyDown);
            m_jBox.on('focus', onFocus);
            m_jBox.on('blur', onBlur);
            m_jBox.on('change', onChange);
            m_jBox.on('keydown keyup', updateBackgroundValue);
            m_strDefaultText = m_internationalization.getString('Enter location, agent name, office name or property address...');
            m_bIndexPage = (window.location.pathname == '/index.c21');

            var v = (m_jBox.val()).trim();
            if ((v != '') && (v != m_strDefaultText)) {
               //m_strLastRequest = v;
               m_jBox.addClass('searchValue');
            } else {
               m_jBox.val(m_strDefaultText);
               m_jBox.removeClass('searchValue');
            }
         },
         formatSearchResults : function() {
         },
         showSearchDrop : function() {
            SearchDropAnimator.showSearchDrop();
            doCollapsing();
            enlargeClickTargets();
            doHighlight();
            fixExpanding();
            ImageLazyLoader.loadImages();
         },
         hideSearchDrop : function() {
            SearchDropAnimator.hideSearchDrop();
         },
         handleHash : function(params) {
            if (!m_bTextDirty) {
               m_jBox.removeClass('searchValue');
               m_jBox.val(params['q']);
            }

            doPortalSearch();
         },
         setText: function(str) {
            m_jBox.val(str);
            m_strLastRequest = m_jBox.val();
         },
         setBehindText: setBehindText
      };
   }());

   /**
    * Handles modifications to Suggestion results
    */
   var SuggestPortalExtension = (function() {
      var m_jSearchDrop, m_iHighlightedIndex, m_jResults;

      /**
       * For a given item in the list, find the text
       * @return {string} ex: "New York, NY"
       */
      function getItemText(jItem) {
         var jItemName = (jItem.hasClass('suggestCollapse') || jItem.hasClass('ftsCollapse')) ? jItem : jItem.find('.suggestCollapse,.ftsCollapse').eq(0),
            // Collapsasaurus will collapse the HTML and set the title,
            // but it doesn't necessarily happen before this is called
            str = jItemName.attr('title') || jItemName.html();
         return str;
      }

      /**
       * Get a sensible name for the type of drop-down being displayed
       * @return {String}
       */
      function getDropDownType() {
         var strSuggestType = $("#suggestType").val();
         switch (strSuggestType) {
            case "NO_SUGGEST":
               return 'suggest';
               break;
            case "SINGLE_LOCATION":
               return "result";
               break;
            case "NO_RESULT":
               return "noresults";
               break;

            // FIXME: What is the text for a disambiguation page?
            default:
               return "disambiguation";
         }
      }
      
      /**
       * Highlight the item at the specified index
       * @param i the index to highlight
       */   
      function setHighlightedIndex(iHighlightedIndex, bUpdateText) {
         var jItem = m_jResults.eq(iHighlightedIndex),
            strNewText = getItemText(jItem);
      
         if (strNewText) {
            strNewText = $.trim(strNewText.split("|")[0]);
         }
         m_jResults.eq(m_iHighlightedIndex).removeClass('hover');
         jItem.addClass('hover');
         m_iHighlightedIndex = iHighlightedIndex;
            
         portalSearch.setBehindText(strNewText);
         
         if (bUpdateText) {
            portalSearch.setText(strNewText);
         }
      }
      
      /**
       * Get the index of the currently highlighted item
       */
      function getHighlightedIndex() {
         return m_iHighlightedIndex;
      }

      /**
       * When the "Suggest" section is loaded
       */   
      function onSuggestLoad() {
         // Highlight every other item
         m_jResults = m_jSearchDrop.find('#searchBody .result');
            
         m_jResults.on('hover', function() {
            setHighlightedIndex(m_jResults.index($(this)));
         }, function() {
            $(this).removeClass('hover');
         });
         
         m_iHighlightedIndex = -1
         
         
         if (m_jResults.length > 0) {
            var jItem = m_jResults.eq(0);
            portalSearch.setBehindText(getItemText(jItem));
         } else {
             var m_jItem = m_jSearchDrop.find('#singleSearchMatch');
             portalSearch.setBehindText(m_jItem.text());
         }

         $("#bedrooms").c21dropdown({
            maxLength: 2,
            tabIndex: 102,
            dropdownClass: 'dropdownCustomizations',
            selectBoxClass: 'selectorCustomizations graySelectBox',
            baseName: 'bedrooms'
         });

         $("#bathrooms").c21dropdown({
            maxLength: 2,
            tabIndex: 104,
            dropdownClass: 'dropdownCustomizations',
            selectBoxClass: 'selectorCustomizations graySelectBox',
            baseName: 'bathrooms'
         });

         $("#structureSize").c21dropdown({
            maxLength: 7,
            tabIndex: 106,
            dropdownClass: 'dropdownCustomizations',
            selectBoxClass: 'selectorSquareFeet graySelectBox',
            baseName: 'structureSize'
         });

         var jPriceOptions = $("#priceOptions"),
            jDropdown = $("#dropdownSearchContent");

         $("#priceFrom").c21textdropdown(jPriceOptions, {
            maxLength: 10,
            tabIndex: 100,
            inputClass: 'priceFromInput',
            dropdownClass: 'dropdownCustomizations dropdownPrice',
            selectBoxClass: 'priceBox',
            parentNode: jDropdown,
            textHint: window.internationalization.getString('Min Price')
         });

         $("#priceTo").c21textdropdown(jPriceOptions, {
            maxLength: 10,
            tabIndex: 101,
            dropdownClass: 'dropdownCustomizations dropdownPrice',
            selectBoxClass: 'priceBox',
            parentNode: jDropdown,
            textHint: window.internationalization.getString('Max Price')
         });
      }

      /**
       * When the document is ready
       */
      function onDocumentReady() {
         m_jSearchDrop = $('#dropdownContent');
         portalAjax.bindLoadEvent(m_jSearchDrop, onSuggestLoad);
      }  
         
      $(document).ready(onDocumentReady);

      return {
         moveUp: function() {
            if (getDropDownType() != 'suggest')
               return;

            var i = getHighlightedIndex() - 1;
         
            if (i < 0) {
               i = m_jResults.length - 1;
            }
            
            setHighlightedIndex(i, true);
         }, 
         
         moveDown: function() {
            if (getDropDownType() != 'suggest')
               return;

            var i = getHighlightedIndex() + 1;
            
            if (i == m_jResults.length) {
               i = 0; 
            }
         
            setHighlightedIndex(i, true);
         }
      };
   }());

   /**
    * Singleton that handles all things surrounding SearchDrop Animation
    */
   var SearchDropAnimator = (function() {
      var m_jDropdownContent,
         m_jDropdownSearchBox,
         m_jDropdownResults,
         m_jDropdownSearchContent,
         m_iSpeed = 150,
         m_bShowing = false,
         m_jSearchBox, m_bSlidingUp, m_bSlidingDown,
         m_bSearchDropVisible, m_bInitialized, m_iSlideSpeedMilliseconds;


      function showDropdown() {
         lazyInit();
         m_jDropdownSearchBox.css({ height: 60 });
         m_jDropdownResults.css({ top: 60 });
         m_jDropdownSearchContent.show();
         m_jDropdownContent.slideDown(m_iSpeed, 'easeOutCubic', function() {
            setTimeout(function() {
               // hasLayout fix for IE7
               m_jDropdownContent.css({
                  zoom: 1
               });
            }, 1);
         });
         m_jSearchBox.addClass('expanded');
         activateWordCollapsasaurus();
      }

      function hideDropdown() {
         // Clear the enter key stroke event
         $("#e").val("");
         $("#singleLocationID").val("");
         $("#suggestType").val("");

         lazyInit();
         m_jDropdownSearchContent.hide();
         m_jDropdownContent.hide();
         m_jDropdownSearchBox.css({ height: 66 });
         m_jDropdownResults.css({ top: 66 });
         m_jSearchBox.removeClass('expanded');
      }

      function toggleDisplay() {
         if (m_bShowing) {
            hideDropdown();
         } else {
            showDropdown();
         }
      
         m_bShowing = !m_bShowing;
      }
      
      function activateWordCollapsasaurus() {
         $('.suggestCollapse').each(function() {
            new WordCollapsasaurus($(this));
         });
      }

      /**
       * Show the content inside of the search box
       */
      function showDropContents() {
         showDropdown();
         m_bSearchDropVisible = true;
         activateWordCollapsasaurus();
      }

      /**
       * Hide the content inside of the search box
       */
      function hideDropContents() {
         hideDropdown();
         m_bSearchDropVisible = false;
      }

      /**
       * Add the onblur event that hides the search box
       */
      function addOnBlurEvent() {
         $(document).on("click", function(e) {
            var jClicked = $(e.target),
               bIsChildOfSearchBox = (jClicked.parents().filter(
                  m_jSearchBox).length > 0);

            if ((e.target == m_jSearchBox.get(0)) || bIsChildOfSearchBox) {
               e.stopPropagation();
               return;
            }

            hideDropdown();
         });
      }

      /**
       * A lazy initialization function, only called when needed
       */
      function lazyInit() {
         // Do not initialize more than once
         if (m_bInitialized)
            return;

         m_bInitialized = true;
         m_jDropdownContent = $("#dropdownContent");
         m_jDropdownSearchBox = $("#dropdownSearchBox");
         m_jDropdownResults = $("#dropdownResults");
         m_jDropdownSearchContent = $("#dropdownSearchContent");

         m_jSearchBox = $('#dropdown');
         m_bSearchDropVisible = false;
         m_iSlideSpeedMilliseconds = 200;
         addOnBlurEvent();
      }

      return {
         hideSearchDrop : hideDropContents,
         showSearchDrop : showDropContents,
         showDropContents : showDropdown,
         hideDropContents : hideDropdown
      }
   }());

   if(!($.browser.msie && $.browser.version=="6.0")) {
      $(document).ready(function() {
         // Do not attempt initialize a background that will never show
         // Ex: mapping page...
         if ($("#mappingHeader").length > 0) return;

         if (!window.disableBGStretcher) {
            if ($.browser.ie && $.browser.version < 9) {
               $('<link>')
                  .appendTo('head')
                  .attr({type : 'text/css', rel : 'stylesheet'})
                  .attr('href', '/css/bgstretcher.css');

               $.getScript('/js/jqueryPlugins/bgstretcher.js', function () {
                  var jWindow = $(window),
                     jDocument = $(document);

                  function activateBackground () {
                     var jBody = $("body"),
                        sBackgroundCss = jBody.css("background-image"),
                        sBackgroundUrl = sBackgroundCss.replace(/"/g,"").replace(/url\(|\)$/ig, "");

                     // Activate background stretcher
                     //jBody.css("background", "none");
                     jDocument.bgStretcher({
                        images: [sBackgroundUrl],
                        imageWidth: 2100,
                        imageHeight: 1200,
                        slideShow: false,
                        resizeProportionally: true
                     });
                  }

                  activateBackground();
               });
            }
         }
      });
   }

   /**
    * Create a ToolTip that is one line in length
    * 
    * (ToolTip Javascript here temporarily, until it is used
    * with more than just the search box)
    */
   window.TooltipOneLine = function(jAttachedTo) {
      var m_jToolTip = $([
         '<div class="tooltipOneLine">',
            '<div class="left" />',
            '<div class="right" />',
            '<div class="center" />',
            '<div class="textContainer"><span class="text" /></div>',
         '</div>'].join('')),
         m_jText = m_jToolTip.find('.text'),
         m_jTextContainer = m_jToolTip.find('.textContainer'),
         m_bShowing = false;

      function reposition() {
         var m_offset = jAttachedTo.offset(),
            m_iTooltipOffset = 15,
            m_iTop = m_offset.top + jAttachedTo.height() - 3;

         // Position the tooltip next to the element
         // that it is attached to
         m_jToolTip.css({
            left: m_offset.left - m_iTooltipOffset,
            top: m_iTop
         });
      }

      function initialize() {
         // Add the tooltip to the document
         $(document.body).append(m_jToolTip);

         // Reposition the tooltip if the window resizes
         $(window).on('resize', reposition);

         // Reposition the tooltip
         reposition();
      }

      /**
       * Hide the tooltip
       */
      this.hide = function() {
         // Slide the tooltip up
         m_jToolTip.animate({
            height: 0
         }, function() {
            // And hide
            m_jToolTip.hide();
         });

         m_bShowing = false;
      };

      /**
       * Show the tooltip with the specified text
       * @param strText  the text to display
       */
      this.showText = function(strText) {
         // If the tooltip is not displaying
         if (!m_bShowing) {
            // Reset the height to 0
            m_jToolTip.css({ height: 0 });

            // Show the tooltip
            m_jToolTip.show();

            // Slide the tooltip down
            m_jToolTip.animate({
               height: 47
            }, function() {
               m_jText.fadeIn();
            });
         }

         m_jText.text(strText);

         // Determine the width of the specified text
         m_jTextContainer.css({ width: 1000 });
         var iNewWidth = m_jText.width() + 50;
         m_jTextContainer.css({ width: '100%' });

         // Hide the text
         m_jText.hide();


         // If showing for the first time,
         // do not do the width animation
         if (!m_bShowing) {
            m_bShowing = true;
            m_jToolTip.width(iNewWidth);
         } else {
            // Fade the text in
            m_jToolTip.animate({
               width: iNewWidth
            }, function() {
               m_jText.fadeIn();
            });
         }
      }

      // Start it up 
      initialize();
   };
}
